import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        'typeSelect',
        'fieldset'
    ]

    connect() {
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let Select2 instances to correctly initialize
        setTimeout(() => {
            this.setFieldsets();
        }, 10)
    }

    setFieldsets() {
        this.fieldsetTargets.forEach( fieldset => {
            if (fieldset.id === this.typeSelectTarget.value) {
                fieldset.disabled = false;
                fieldset.style.display = 'block';
                this.setFieldsetSelects(fieldset, false);
            } else {
                fieldset.disabled = true;
                fieldset.style.display = 'none';
                this.setFieldsetSelects(fieldset, true);
            }
        });
    }

    setFieldsetSelects(fieldset, disabled) {
        const selects = fieldset.getElementsByTagName('select');

        [...selects].forEach( select => {
            select.disabled = disabled;
        });
    }
}